import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b7c364a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_2 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_3 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_4 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_5 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_6 = {
  style: {"font-size":"small"},
  "justify-start": ""
}
const _hoisted_7 = { style: {"font-size":"large","font-weight":"500"} }
const _hoisted_8 = {
  style: {"font-size":"small"},
  "justify-start": ""
}

import { useI18n } from "vue-i18n"
import { computed, ref } from "vue"
import { Hospital } from "@/types"
import HospitalDoctorInfo from "./HospitalDoctorInfo.vue"
import router from "@/router"
import { useUserActions } from "@/stores/user-actions"
import HospitalApply from "./HospitalApply.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalSpecialInfo',
  props: {
    hospital: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const props = __props
const hospital = ref<Hospital | undefined>(props.hospital)
const tab = ref("")
const lorem = ref(
  "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ad eos adipisci corporis, dolore quidem perspiciatis officiis voluptatibus soluta molestiae asperiores, libero rem fugiat quam iusto, cumque distinctio nesciunt dolorum labore?"
)
const applyClicked = ref(false)
const userAction = useUserActions()

const apply = async () => {
  localStorage.setItem("hospitalId", hospital.value?._id ?? "")

  const token = localStorage.getItem("accessToken") ?? null
  if (token) {
    const response = await userAction.getStudentProfile(token)
    if (response.success) {
      localStorage.removeItem("hospitalId")
      tab.value = "APPLY"
    } else {
      router.push("/login")
    }
  } else {
    router.push("/login")
  }

  applyClicked.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, {
      class: "mr-2",
      height: "820",
      elevation: "5",
      style: {"overflow-y":"scroll"}
    }, {
      default: _withCtx(() => [
        (!applyClicked.value)
          ? (_openBlock(), _createBlock(_component_v_tabs, {
              key: 0,
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
              "show-arrows": "",
              "bg-color": "#25344d",
              "fixed-tabs": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "INFORMATION" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.general-information")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "DOCTORS" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.doctors")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createBlock(_component_v_tabs, {
              key: 1,
              modelValue: tab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
              "show-arrows": "",
              "bg-color": "#25344d",
              "fixed-tabs": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "INFORMATION" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.general-information")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "DOCTORS" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("hospital.doctors")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "APPLY" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("apply")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])),
        _createVNode(_component_v_window, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "INFORMATION" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  lines: "one",
                  class: "mt-5",
                  align: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-star" })
                          ]),
                          _: 1
                        })
                      ]),
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("doctor.famulatur")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(hospital.value?.selectReason ?? lorem.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, {
                  lines: "one",
                  align: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-clipboard-list" })
                          ]),
                          _: 1
                        })
                      ]),
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("doctor.requirement")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(hospital.value?.requirementsForStudent ?? lorem.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, {
                  lines: "one",
                  align: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-currency-eur" })
                          ]),
                          _: 1
                        })
                      ]),
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("doctor.financial-help")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(hospital.value?.financialDescription ?? lorem.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list, {
                  lines: "one",
                  align: "start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, null, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_avatar, { color: "blue-darken-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-home-city" })
                          ]),
                          _: 1
                        })
                      ]),
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("doctor.area")), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(hospital.value?.areaDescription ?? lorem.value), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!applyClicked.value)
                  ? (_openBlock(), _createBlock(_component_v_card_actions, {
                      key: 0,
                      class: "justify-center mt-10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          rounded: "lg",
                          color: "#3fb984",
                          variant: "flat",
                          size: "large",
                          width: "180",
                          onClick: apply
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("apply")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "DOCTORS" }, {
              default: _withCtx(() => [
                _createVNode(HospitalDoctorInfo, { hospital: hospital.value }, null, 8, ["hospital"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "APPLY" }, {
              default: _withCtx(() => [
                _createVNode(HospitalApply, { hospital: hospital.value }, null, 8, ["hospital"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})